import { quillRedefine } from "./vueQuillEditorUpload";
import { Message } from 'element-ui';
import route from '@/router/index';
import store from '@/store/index';
import config from '@/config/default'


/**
 * 富文本图片上传
 * @param {文件夹名称} urlName 
 */
const editorOption = (urlName: string) => {
  return quillRedefine({
    // 图片上传的设置
    uploadConfig: {
      action: config.uploadImg + urlName || 'product', // 必填参数 图片上传地址
      start: () => {
        Message({
          message: "正在上传,请稍候...",
          duration: 0,
          showClose: true,
          type: "info"
        });
      },
      end: () => {
        let mes: any = Message
        mes.closeAll();
      },
      res: (res: any) => {
        let mes: any = Message
        mes.close();
        if (res.code == 200) {
          Message.success("上传成功!");
          let baseUrl = config.uploadImgUrl
          return baseUrl + "/" + res.data.url;
        } else {
          res.code == 401 ? route.replace("login") : null;
          Message.error(res.message);
        }
      },
      sizeError: (size:number) => {
        Message.error(`图片尺寸太大，请控制在${size}kb以内！`);
      },
      token: store.getters.token,
      size: 512,
      methods: "POST",
      name: "file" // 图片上传参数名
    }
  });
}

export default editorOption